import React, { useState, useEffect } from "react";
import { StyledHeader } from "./ClubFinancial";
import LabelText from "../../../ui/LabelText";
import { IPlayerWages, IplayerTrading } from "../../../types/IClubDetail";
import { IFinancialChartData } from "../../../types/IClubDetail";
import FinancialBarchart from "./FinancialBarchart";

interface PlayerWagesProps {
  data: IPlayerWages | undefined;
}

const PlayerWages: React.FC<PlayerWagesProps> = ({ data }) => {
  const [financialChartData, setFinancialChartData] = useState<IFinancialChartData[]>([]);

  useEffect(() => {
    setFinancialChartData([
      { name: "Total wages", value: data?.totalWages, valueText: data?.totalWagesText, color: "#00D1A8", type: "revenue" },
      {
        name: "Regular starters",
        value: data?.regularStarterPlayerWages,
        valueText: data?.regularStarterPlayerWagesText,
        color: "#FFC2C2",
        type: "cost",
      },
      {
        name: "Squad & fringe",
        value: data?.squadFringePlayerWages,
        valueText: data?.squadFringePlayerWagesText,
        color: "#C9F0B5",
        type: "cost",
      },
    ]);
  }, [data]);

  return (
    <>
      <StyledHeader className="header-content">
        <LabelText className="drawer-title">Player wages</LabelText>
      </StyledHeader>
      <div className="overview-container">
        <FinancialBarchart data={financialChartData} />
      </div>
    </>
  );
};

export default PlayerWages;
